import type { AddButton } from 'ricos-types';
import { Node_Type } from 'ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { Uploader } from 'wix-rich-content-plugin-commons';

import { RICOS_DEFAULTS } from './consts';
import { InsertPluginIcon } from './icons';
import { ImagePluginService } from './toolbar/imagePluginService';
import { IMAGE_TYPE } from './types';

const imagePluginService = new ImagePluginService();

const handleExternalFileChange =
  (editorCommands, updateService) =>
  ({ data }) => {
    if (data instanceof Array) {
      data.forEach((file, index) => {
        setTimeout(() => {
          const nodeId = editorCommands.insertBlockWithBlankLines(IMAGE_TYPE, RICOS_DEFAULTS, {
            updateSelection: data.length === index + 1,
          });
          updateService.updatePluginData({ data: file }, nodeId, IMAGE_TYPE, imagePluginService);
        });
      });
    } else {
      const nodeId = editorCommands.insertBlockWithBlankLines(IMAGE_TYPE, RICOS_DEFAULTS);
      updateService.updatePluginData({ data }, nodeId, IMAGE_TYPE, imagePluginService);
    }
  };

const handleNativeFileChange = (editorCommands, uploadService, uploader) => (files: File[]) => {
  files.forEach((file, index) => {
    // prevents rerenders when next file starts uploading
    setTimeout(() => {
      const nodeId = editorCommands.insertBlockWithBlankLines(IMAGE_TYPE, RICOS_DEFAULTS, {
        updateSelection: files.length === index + 1,
      });
      uploadService.uploadFile(
        new File([file], file.name, { type: file.type }),
        nodeId,
        uploader,
        IMAGE_TYPE,
        imagePluginService
      );
    });
  });
};

export const imageAddToolbars: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
];

export const getAddButtons = (config, services): AddButton[] => {
  return [
    {
      id: Node_Type.IMAGE,
      label: INSERT_PLUGIN_BUTTONS.IMAGE,
      dataHook: INSERT_PLUGIN_BUTTONS.IMAGE,
      icon: InsertPluginIcon,
      tooltip: 'ImagePlugin_InsertButton_Tooltip',
      toolbars: imageAddToolbars,

      command: ({ editorCommands }) => {
        const { uploadService, updateService } = services;
        if (config.handleFileSelection) {
          config.handleFileSelection(
            undefined,
            !!config.multi,
            handleExternalFileChange(editorCommands, updateService),
            undefined,
            RICOS_DEFAULTS
          );
        } else {
          const { accept = 'image/*', multi = true, handleFileUpload } = config;
          uploadService?.selectFiles(
            accept,
            multi,
            handleNativeFileChange(editorCommands, uploadService, new Uploader(handleFileUpload))
          );
        }
        return true;
      },
      menuConfig: {
        tags: 'Image_plugin_search_tags',
      },
    },
  ];
};
